import { v4 as uuidv4 } from 'uuid';
import axios from 'axios';
import { getConfig, isWidgetConfig } from './config';
/**
 * @deprecated Use `registerXHeadersInterceptor` instead.
 */
export const registerAdditionalHeadersInterceptor = (settings, instance) => {
    const interceptorId = instance.interceptors.request.use(config => {
        config.headers['x-converse-client'] = `${settings.hostName}/${settings.hostRevision}`;
        config.headers['x-converse-platform'] = 'web';
        config.headers['x-converse-language'] = window.navigator.language;
        config.headers['x-converse-request-id'] = uuidv4();
        return config;
    });
    return () => {
        instance.interceptors.request.eject(interceptorId);
    };
};
export const registerXHeadersInterceptor = (instance) => {
    const interceptorId = instance.interceptors.request.use(requestConfig => {
        const config = getConfig();
        requestConfig.headers['x-converse-client'] = config.client
            .map(pair => pair.filter(Boolean).join('/'))
            .join('; ');
        requestConfig.headers['x-converse-platform'] = 'web';
        requestConfig.headers['x-converse-language'] = window.navigator.language;
        requestConfig.headers['x-converse-request-id'] = uuidv4();
        if (isWidgetConfig(config)) {
            if (config.platform) {
                // override platform for clients that are "not" web (e.g. webview)
                requestConfig.headers['x-converse-platform'] = config.platform;
            }
            if (config.deviceId) {
                requestConfig.headers['x-converse-device-id'] = config.deviceId;
            }
        }
        return requestConfig;
    });
    return () => {
        instance.interceptors.request.eject(interceptorId);
    };
};
export const isUnauthorizedError = (queryError) => axios.isAxiosError(queryError) && queryError.response?.status === 401;
//# sourceMappingURL=axios.js.map